module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-1250.ac3d1fc7.svg";